import { render, staticRenderFns } from "./LanguageSwitcherWidget.vue?vue&type=template&id=079fdc62&"
import script from "./LanguageSwitcherWidget.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitcherWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports